import { useMemo, useRef } from "react";
import { Typography } from "antd";
import moment from "moment";

import { ICongelamentosUnicosExtrato } from "../../interfaces";

import { convertHora, convertMoedaBRDoJSComAte3CasasDecimais } from "../../../../../../services/Conversores";
import { useGetColumnSearchPropsData } from "../../../../../../hooks/FilterTable/date";
import { useGetColumnSearchProps } from "../../../../../../hooks/FilterTable/string";
import { formatarTextoComAcentosCompleto, maskCNPJ } from "../../utils";

const { Text } = Typography;

export const useAbaCongelamentosUnicos = (congelamentos: ICongelamentosUnicosExtrato[]) => {
    const refContagemDoFiltro = useRef<Array<any>>([]);

    const tipos = useMemo(() => {
        const tiposArray = congelamentos.reduce((prev, current) => {
            return [
                ...prev,
                current.tipo,
            ]
        }, [] as string[]);

        const tiposUnicos = Array.from(new Set(tiposArray));

        const tiposFormatados = tiposUnicos.map((e) => ({
            value: e,
            label: formatarTextoComAcentosCompleto(e),
        }));

        return tiposFormatados;
    }, [congelamentos]);

    const columns = [
        {
            title: 'CNPJ',
            dataIndex: 'cnpj',
            ...useGetColumnSearchProps('cnpj'),
            width: '10%',
            sorter: (a: any, b: any) => a?.cnpj?.localeCompare(b?.cnpj),
            showSorterTooltip: false,
            render: (cnpj: any) => {
                return maskCNPJ(cnpj)
            },
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
            width: '10%',
            sorter: (a: any, b: any) => a.tipo.localeCompare(b.tipo),
            showSorterTooltip: false,
            filters: tipos?.map((e) => ({
                text: e.label || '',
                value: e.value || '',
            })),
            onFilter: (value: any, record: any) => {
                const columnValue = record.tipo;
                return columnValue === value;
            },
            render: (val: string) => {
                return (
                    <Text>{formatarTextoComAcentosCompleto(val)}</Text>
                )
            },
        },
        {
            title: 'Hora',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (data: any) => {

                return (
                    convertHora(data)
                )
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...useGetColumnSearchProps('usuario'),
            width: '10%',
            sorter: (a: any, b: any) => a?.usuario.nome?.localeCompare(b?.usuario.nome),
            showSorterTooltip: false,
            render: (usuario: any) => {
                return usuario.nome;
            }
        },
        {
            title: 'Custo',
            dataIndex: 'custo',
            ...useGetColumnSearchProps('custo'),
            width: '6%',
            sorter: (a: ICongelamentosUnicosExtrato, b: ICongelamentosUnicosExtrato) => a.custo - b.custo,
            showSorterTooltip: false,
            render: (valor: number) => {
                return `R$ ${convertMoedaBRDoJSComAte3CasasDecimais(valor, true)}`;
            }
        },
    ];

    return {
        refContagemDoFiltro,
        columns,
    }
}
